import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Reveal from '@/components/Reveal';
import KpiCounter from '@/components/KpiCounter';
import { CASE_STUDIES, AGENCY_KPIS } from '@/data/caseStudies';

export default function CaseStudiesSection() {
  return (
    <section id="case-studies" className="bg-[#0B0B0B] border-t border-white/10 py-20 lg:py-28">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#3B82F6] block mb-4">
            Proven Results
          </span>
          <h2 className="font-display font-bold tracking-tight text-3xl lg:text-5xl text-white leading-tight">
            Work measured in outcomes, not impressions.
          </h2>
          <p className="mt-6 text-white/55 font-light leading-relaxed">
            A selection of engagements across automotive, beauty and luxury hospitality — each briefed,
            produced and scaled in-house by our talent and production divisions.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-lg overflow-hidden border border-white/10">
          {AGENCY_KPIS.map((k, i) => (
            <Reveal key={k.label} delay={i * 0.08} className="bg-[#0B0B0B]">
              <div className="px-6 py-8 lg:px-8 lg:py-10">
                <div className="text-3xl lg:text-4xl text-white">
                  <KpiCounter {...k} />
                </div>
                <p className="mt-3 text-[11px] uppercase tracking-[0.16em] text-white/45 leading-relaxed">
                  {k.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-6 grid md:grid-cols-3 gap-6">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.client} delay={i * 0.1}>
              <article className="h-full flex flex-col rounded-lg border border-white/10 bg-white/[0.02] p-7 lg:p-8 hover:border-[#3B82F6]/50 transition-colors duration-300">
                <div className="flex items-start justify-between gap-4">
                  <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-[#3B82F6]">
                    {c.sector}
                  </span>
                  <ArrowUpRight className="w-4 h-4 text-white/25" />
                </div>
                <h3 className="mt-5 font-display font-bold text-xl text-white tracking-tight leading-snug">
                  {c.headline}
                </h3>
                <p className="mt-2 text-xs uppercase tracking-[0.14em] text-white/40">{c.client}</p>
                <p className="mt-4 text-sm text-white/55 font-light leading-relaxed">{c.summary}</p>

                <dl className="mt-7 pt-6 border-t border-white/10 space-y-3">
                  {c.metrics.map((m) => (
                    <div key={m.k} className="flex items-baseline justify-between gap-4">
                      <dt className="text-xs text-white/45">{m.k}</dt>
                      <dd className="font-display font-bold text-base text-white">{m.v}</dd>
                    </div>
                  ))}
                </dl>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}